import { Icon, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export const CompanyNameTooltipIcon = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Tooltip placement="top" label={t('e_invoice.kyc.step.company_details.form.company_name.tooltip')}>
      <Icon icon="circleQuestionMark" />
    </Tooltip>
  )
}
